import PropTypes from 'prop-types'
import { Component } from 'react'

import AcceptPrivacyPolicy from 'components/authentication/form-fields/AcceptPrivacyPolicy'
import passwordOutcome from 'components/authentication/passwordOutcome'
import { PasswordRules } from 'components/authentication/PasswordRules'
import Button from 'components/common/Button'
import InputTextField from 'components/common/InputTextField'

export default class SetPassword extends Component {
  static propTypes = {
    location: PropTypes.object,
    handleChange: PropTypes.func,
    handleAcceptPrivacyPolicyChange: PropTypes.func,
    password: PropTypes.string,
    submitLabel: PropTypes.string,
    confirmPassword: PropTypes.string,
    privacyPolicyAccepted: PropTypes.bool,
    isLoading: PropTypes.bool,
    hideAcceptPrivacyPolicy: PropTypes.bool
  }

  submitInvalid() {
    const { password, confirmPassword } = this.props
    return passwordOutcome(password, confirmPassword).some(
      (rule) => rule.invalid
    )
  }

  render() {
    const {
      password,
      confirmPassword,
      submitLabel,
      handleAcceptPrivacyPolicyChange,
      privacyPolicyAccepted,
      handleChange,
      isLoading,
      hideAcceptPrivacyPolicy
    } = this.props

    return (
      <div className="formFields">
        <InputTextField
          label="Password"
          name="password"
          type="password"
          value={password}
          onChange={handleChange}
        />
        <InputTextField
          label="Confirm Password"
          name="confirmPassword"
          type="password"
          value={confirmPassword}
          onChange={handleChange}
        />
        <PasswordRules
          passwordOutcome={passwordOutcome(password, confirmPassword)}
        />
        {!hideAcceptPrivacyPolicy && (
          <AcceptPrivacyPolicy
            privacyPolicyAccepted={privacyPolicyAccepted}
            onChange={handleAcceptPrivacyPolicyChange}
          />
        )}
        <Button
          data-test-submit-password
          stretch
          disabled={
            this.submitInvalid() ||
            (!hideAcceptPrivacyPolicy && !privacyPolicyAccepted)
          }
          label={submitLabel || 'Continue'}
          loading={isLoading}
          type="submit"
        />
      </div>
    )
  }
}
